import React from 'react';
import { ReviewTabEnum, ReviewTabType } from 'v2/models';
import { Tab, Tabs } from '@material-ui/core';
import classnames from 'classnames';
import styles from './reviewTabs.module.scss';
import Count from 'v2/common/Count/Count';
import useGetBadgeCount from 'v2/queries/useGetBadgeCount';

export const TABS: ReviewTabType[] = [
  {
    eventKey: ReviewTabEnum.needs_review,
    title: 'needs review',
  },
  {
    eventKey: ReviewTabEnum.actioned,
    title: `actioned`,
  },
];

export const defaultTab = TABS[0].eventKey;
interface ReviewTabsProps {
  currentTab: ReviewTabType['eventKey'];
  onTabChange: (tab: ReviewTabType['eventKey']) => void;
}

const ReviewTabs = ({ currentTab, onTabChange }: ReviewTabsProps) => {
  const { data: badges } = useGetBadgeCount();

  const handleTabChange = (
    event: React.ChangeEvent<unknown>,
    newValue: ReviewTabType['eventKey']
  ) => {
    onTabChange(newValue || defaultTab);
  };

  const getBadgeCount = (searchType: 'needs_review' | 'actioned') => {
    return badges?.[searchType]?.count || 0;
  };

  return (
    <div className={classnames(styles.tabs_container)}>
      <Tabs
        value={currentTab}
        onChange={handleTabChange}
        indicatorColor="primary"
        textColor="primary"
        data-cy="requests:tabs"
      >
        {TABS.map((item) => (
          <Tab
            key={item.eventKey}
            className={classnames(styles.tabs)}
            value={item.eventKey}
            label={
              <div className="d-flex">
                {item.title}{' '}
                <Count
                  className={styles.topCount}
                  value={getBadgeCount(item.eventKey)}
                />
              </div>
            }
            disableRipple
          ></Tab>
        ))}
      </Tabs>
      <div className={styles.border}></div>
    </div>
  );
};

export default ReviewTabs;
